import * as React from 'react';
import { FocusRing } from 'react-aria';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import S from './Textbox.styles';
const maskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: 8,
    allowNegative: false,
    allowLeadingZeroes: false,
};
const Textbox = React.forwardRef(({ prefix, suffix, setValue, initialValue, ...props }, ref) => {
    const currencyMask = createNumberMask(maskOptions);
    const [maskedValue, setMaskedValue] = React.useState(initialValue ?? '');
    React.useEffect(() => {
        setMaskedValue(initialValue ?? '');
        setValue?.(initialValue ? initialValue.replace(/,/g, '') : '');
    }, [initialValue]);
    const otherProps = {};
    if (props.type === 'number') {
        otherProps.step = 'any';
    }
    if (prefix && prefix === '£') {
        return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.InputWrapper, { "data-type": "currency" },
                prefix && React.createElement(S.Prefix, null, prefix),
                React.createElement(MaskedInput, { mask: currencyMask, onChange: (e) => {
                        setValue?.(e.target.value.replace(/,/g, ''));
                        setMaskedValue(e.target.value);
                    }, inputMode: "numeric", value: maskedValue }),
                React.createElement("input", { ref: ref, ...props, "aria-labelledby": `${props.name}-label`, ...otherProps, type: "hidden" }),
                suffix && React.createElement(S.Suffix, null, suffix))));
    }
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.InputWrapper, null,
            prefix && React.createElement(S.Prefix, null, prefix),
            React.createElement(S.Input, { ref: ref, ...props, "aria-labelledby": `${props.name}-label`, ...otherProps }),
            suffix && React.createElement(S.Suffix, null, suffix))));
});
Textbox.displayName = 'Textbox';
export default Textbox;
